import {
    allFetch
} from "../Domain";

/**
 * @description 請假
 */
export const Leave = (() => {
    /**
     * @description 使用者剩餘請假天數查詢(特休專用)
     * @param {string} year 年資
     * @param {string} user_ids 帳號編號們
     * @param {string} company_id 公司流水號
     * @param {string} general_manager_id 高階管理階層（前總經理室）流水號
     * @param {string} department_id 部門流水號
     * @param {string} position_id 廠別流水號
     * @param {string} class_id 課級流水號
     * @param {string} group_id 組級流水號
     * @param {string} office_id 辦公室流水號
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @returns res
     */
    const LeaveRemainAnnualSearch = async (obj = {
        year: '',
        user_ids: new Array(),
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        page: '',
        num_per_page: ''
    }) => {
        return await allFetch("Leave/LeaveRemainAnnualSearch", obj);
    }
    /**
     * @description 假別修改部分欄位(特修補休只用到請假最小單位)
     * @returns res
     */
    const LeaveRemainAnnualUpdate = async (obj = {
        user_id: '',
        year: '',
        day_get: '',
        day_remain: ''
    }) => {
        return await allFetch("Leave/LeaveRemainAnnualUpdate", obj);
    }
    /**
     * @description 使用者剩餘請假天數查詢(特休除外)
     * @param {string} year 年資
     * @param {string} leave_rule_no_annual_id 假別流水號
     * @param {string} date_start 日期起
     * @param {string} date_end 日期迄
     * @param {string} user_ids 帳號編號們
     * @param {string} company_id 公司流水號
     * @param {string} general_manager_id 高階管理階層（前總經理室）流水號
     * @param {string} department_id 部門流水號
     * @param {string} position_id 廠別流水號
     * @param {string} class_id 課級流水號
     * @param {string} group_id 組級流水號
     * @param {string} office_id 辦公室流水號
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     * @returns res
     */
    const LeaveRemainNoAnnualSearch = async (obj = {
        year: '',
        leave_rule_no_annual_id: '',
        date_start: '',
        date_end: '',
        user_ids: new Array(),
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        page: '',
        num_per_page: ''
    }) => {
        return await allFetch("Leave/LeaveRemainNoAnnualSearch", obj);
    }
    /**
     * @description 使用者剩餘請假天數查詢(某一人當年度特休剩餘天數、請假時看的)
     * @param {string} user_id 帳號編號
     * @returns res
     */
    const LeaveRemainAnnualSearchOwn = async (obj = {
        user_id: ''
    }) => {
        return await allFetch("Leave/LeaveRemainAnnualSearchOwn", obj);
    }
    /**
     * @description 使用者剩餘請假天數查詢(某一人還能用的補休分鐘數、請假時看的)
     * @param {string} user_id 帳號編號
     * @returns res
     */
    const LeaveRemainCompensateSearchOwn = async (obj = {
        user_id: ''
    }) => {
        return await allFetch("Leave/LeaveRemainCompensateSearchOwn", obj);
    }
    /**
     * @description 假別查詢
     * @param {string} user_id 帳號編號
     * @returns res
     */
    const LeaveRuleNoAnnualSearch = async (obj = {
        leave_rule_no_annual_id: '',
        visible: '',
        user_id: ''
    }) => {
        return await allFetch("Leave/LeaveRuleNoAnnualSearch", obj);
    }
    /**
     * @description 假別修改部分欄位(特修補休只用到請假最小單位)
     * @returns res
     */
    const LeaveRuleNoAnnualUpdate = async (obj = {
        leave_rule_no_annual_id: '',
        min_unit_type: '',
        min_unit_num: '',
        basic_day: '',
        few_days_before: '',
        few_days_after: '',
        divisible: '',
        need_document: '',
        deadline_note: '',
        document_note: '',
        visible: ''
    }) => {
        return await allFetch("Leave/LeaveRuleNoAnnualUpdate", obj);
    }

    /**
     * @description 請假申請查詢
     * @returns res
     */
    const LeaveRecordSearch = async (obj = {
        eave_record_id: '',
        leave_rule_no_annual_id: '',
        date_start: '',
        date_end: '',
        statuses: '',
        user_ids: [],
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        page: 0,
        num_per_page: 10
    }) => {
        return await allFetch("Leave/LeaveRecordSearch", obj);
    }

    /**
     * @description 請假申請建立
     * @returns res
     */
    const LeaveRecordCreate = async (obj) => {
        return await allFetch("Leave/LeaveRecordCreate", obj);
    }

    /**
     * @description 銷假申請建立
     * @returns res
     */
    const LeaveRecordCancelCreate = async (obj = {
        leave_record_id: '',
        note: ''
    }) => {
        return await allFetch("Leave/LeaveRecordCancelCreate", obj);
    }

    /**
     * @description 銷假 申請審核
     * @returns res
     */
    const LeaveRecordCancelAudit = async (obj = {
        leave_record_id: '',
        status: '',
        note: ''
    }) => {
        return await allFetch("Leave/LeaveRecordCancelAudit", obj);
    }

    /**
     * @description 請假申請審核
     * @returns res
     */
    const LeaveRecordAudit = async (obj = {
        leave_record_id: '',
        status: '',
        note: ''
    }) => {
        return await allFetch("Leave/LeaveRecordAudit", obj);
    }

    /**
     * @description 剩餘特休補休天數結算紀錄查詢
     * @returns res
     */
    const LeaveRemainSettleLogSearch = async (obj = {
        date_start: '',
        date_end: '',
        page: 0,
        num_per_page: 10
    }) => {
        return await allFetch("Leave/LeaveRemainSettleLogSearch", obj);
    }

    /**
     * @description 剩餘有薪休假天數統計
     * @returns res
     */
    const LeaveRemainStatistic = async (obj = {
        date_start: '',
        date_end: '',
        user_ids: [],
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        excel: 'N',
        page: 0,
        num_per_page: 10
    }) => {
        return await allFetch("Leave/LeaveRemainStatistic", obj);
    }

    /**
     * @description 剩餘特休補休天數結算
     * @returns res
     */
    const LeaveRemainSettle = async (obj = {
        lra_ids: [],
        lrna_ids: [],
    }) => {
        return await allFetch("Leave/LeaveRemainSettle", obj);
    }

    /**
     * @description 剩餘特休補休天數結算紀錄細項
     * @returns res
     */
    const LeaveRemainSettleLogDetail = async (obj = {
        id: ''
    }) => {
        return await allFetch("Leave/LeaveRemainSettleLogDetail", obj);
    }

    return {
        LeaveRemainAnnualSearch,
        LeaveRemainNoAnnualSearch,
        LeaveRemainAnnualUpdate,
        LeaveRemainAnnualSearchOwn,
        LeaveRemainCompensateSearchOwn,
        LeaveRuleNoAnnualSearch,
        LeaveRuleNoAnnualUpdate,
        LeaveRecordSearch,
        LeaveRecordCreate,
        LeaveRecordCancelCreate,
        LeaveRecordCancelAudit,
        LeaveRecordAudit,
        LeaveRemainSettleLogSearch,
        LeaveRemainStatistic,
        LeaveRemainSettle,
        LeaveRemainSettleLogDetail
    }
})();